module.exports = __webpack_public_path__ + "img/icon_status@2x.9517690a.png";